import { render, staticRenderFns } from "./companySettingPage.vue?vue&type=template&id=2a213967&"
import script from "./companySettingPage.vue?vue&type=script&lang=ts&"
export * from "./companySettingPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports